import {Component, Input, OnChanges, OnInit, SimpleChanges, ViewChild} from '@angular/core';
import {ReportsService} from '../../reports.service';
import {appColors} from '../../../core/styles/colors';
import {EChartsOption, SeriesOption} from 'echarts';
import {DurationPipe} from '../../../core/pipes/duration.pipe';
import {chartBarIcon, chartDefaultOptions, chartExpandIcon, chartPieIcon} from '../../../core/styles/chart-defauls';
import {LegendOption} from 'echarts/types/dist/shared';
import {MatDialog} from '@angular/material/dialog';
import {MatGroupsDashboardZoomDialogComponent} from './mat-groups-dashboard-zoom-dialog.component';
import { NgxEchartsDirective } from 'ngx-echarts';

@Component({
    selector: 'app-chart-by-groups',
    templateUrl: './chart-by-groups.component.html',
    standalone: true,
    imports: [NgxEchartsDirective]
})
export class ChartByGroupsComponent implements OnInit, OnChanges {

  @Input() public data: any[] = [];
  @Input() selectedFilterType = {action: 99, text: 'Total Calls'};
  @Input() showTimeSeries = false;
  @Input() showExpand = false;
  @Input() chartType: 'bar' | 'pie' = 'bar';

  @ViewChild('expandBtn') expandBtn;

  colors = appColors;
  updateOptions: EChartsOption = {};
  initOptions = {};

  options: EChartsOption;

  optionsBar: EChartsOption = {
    title: Object.assign({}, chartDefaultOptions.title, {
      text: 'Total Calls By Groups'
    }),
    legend: Object.assign({}, chartDefaultOptions.legend),
    grid: Object.assign({}, chartDefaultOptions.grid),
    toolbox: [{
      show: true,
      feature: {
        dataZoom: {
          yAxisIndex: 'none'
        },
        myBar: {
          show: true,
          title: 'Switch to Bar Chart',
          icon: chartBarIcon,
          iconStatus: {
            myBar: 'emphasis',
            myPie: 'normal'
          },
          onclick: () => {
            console.log('on expand click');
            this.expandBtn.nativeElement.value = 'bar';
            this.expandBtn.nativeElement.click();
          }
        },
        myPie: {
          show: true,
          title: 'Switch to Pie Chart',
          icon: chartPieIcon,
          onclick: () => {
            console.log('on expand click');
            this.expandBtn.nativeElement.value = 'pie';
            this.expandBtn.nativeElement.click();
          }
        },
        saveAsImage: {},
        myZoom: {
          show: this.showExpand,
          title: 'Expand',
          icon: chartExpandIcon,
          onclick: () => {
            console.log('on expand click');
            this.expandBtn.nativeElement.value = 'zoom';
            this.expandBtn.nativeElement.click();
          }
        }
      }
    }],
    dataZoom: [
      {
        type: 'inside',
        filterMode: 'filter',
        start: 0,
        end: 100,
      },
      {
        start: 0,
        end: 100,
      },
    ],
    xAxis: {
      type: 'category',
    },
    yAxis: [{
      type: 'value',
      scale: true,
      min: 0,
      axisLine: {
        show: true,
      },
      name: 'Total Count',
      nameGap: 30,
      nameRotate: 90,
      nameLocation: 'middle',
      axisLabel: {
        formatter: (value) => {
          if (this.showTimeSeries) {
            return this.durationPipe.transform(value);
          } else {
            return `${value}`;
          }
        }
      }
    }],
    series: [],
    tooltip: {
      show: true,
      trigger: 'axis',
      axisPointer: {
        label: {
          formatter: (params) => {
            const name = this.reportsService.getExtensionName(params.value as string);
            return name || params.value;
          }
        }
      },
      valueFormatter: (value: any) => {
        if (this.showTimeSeries) {
          return this.durationPipe.transform(value);
        } else {
          return value;
        }
      }
    },
  };

  optionsPie: EChartsOption = {
    title: Object.assign({}, chartDefaultOptions.title, {
      text: 'Total Calls By Groups'
    }),
    legend: Object.assign({}, chartDefaultOptions.legend, {orient: 'vertical', left: 'auto'}),
    grid: Object.assign({}, chartDefaultOptions.grid),
    toolbox: [{
      show: true,
      feature: {
        myBar: {
          show: true,
          title: 'Switch to Bar Chart',
          icon: chartBarIcon,
          iconStatus: 'select',
          onclick: () => {
            console.log('on expand click');
            this.expandBtn.nativeElement.value = 'bar';
            this.expandBtn.nativeElement.click();
          }
        },
        myPie: {
          show: true,
          title: 'Switch to Pie Chart',
          icon: chartPieIcon,
          iconStatus: {
            myBar: 'normal',
            myPie: 'emphasis'
          },
          onclick: () => {
            console.log('on expand click');
            this.expandBtn.nativeElement.value = 'pie';
            this.expandBtn.nativeElement.click();
          }
        },
        saveAsImage: {},
        myZoom: {
          show: this.showExpand,
          title: 'Expand',
          icon: chartExpandIcon,
          onclick: () => {
            console.log('on expand click');
            this.expandBtn.nativeElement.value = 'zoom';
            this.expandBtn.nativeElement.click();
          }
        }
      }
    }],
    series: [],
    tooltip: {
      show: true,
      trigger: 'item',
      axisPointer: {
        label: {
          formatter: (params) => {
            const name = this.reportsService.getExtensionName(params.value as string);
            return name || params.value;
          }
        }
      },
      valueFormatter: (value: any) => {
        if (this.selectedFilterType.action === 4 || this.selectedFilterType.action === 5) {
          return this.durationPipe.transform(value);
        } else {
          return value;
        }
      }
    },
  };

  private chart: any;

  constructor(public reportsService: ReportsService,
              public durationPipe: DurationPipe,
              public dialog: MatDialog) {
    const resizeObserver = new ResizeObserver(() => {
      this.resizeChart();
    });
    resizeObserver.observe(document.body);
  }

  ngOnInit() {
    console.log('my on init');
  }

  resizeChart() {
    if (this.chart) {
      this.chart.resize();
    }
  }

  onChartInit($event: any) {
    this.chart = $event;
    console.log('on chart init:', $event);
  }

  ngOnChanges(changes: SimpleChanges): void {
    console.log('my on ngOnChanges');

    this.updateChart();
  }

  updateChart() {

    const groupedData = [...this.data];

    const series = [];

    if (this.chartType === 'bar') {
      this.options = Object.assign({}, this.optionsBar);

      const answeredCalls: SeriesOption = {
        type: 'bar',
        name: 'Groups Answered Calls',
        barMaxWidth: 80,
        data: groupedData.map(item => {
          return item.answeredByUser;
        }),
        color: this.colors.primaryGreen,
        stack: 'calls'
      };

      const totalAgents: SeriesOption = {
        type: 'bar',
        name: 'Active Agents',
        barMaxWidth: 80,
        data: groupedData.map(item => {
          return item.usersCount;
        }),
        color: this.colors.teal,
        stack: ''
      };

      const missedCalls: SeriesOption = {
        type: 'bar',
        name: 'Abandoned By Groups',
        barMaxWidth: 80,
        data: groupedData.map(item => {
          return item.missedCalls;
        }),
        color: this.colors.primaryRed,
        stack: 'calls'
      };

      // series.push(totalCalls);
      series.push(answeredCalls);
      series.push(missedCalls);
      series.push(totalAgents);

      (this.options.legend as LegendOption).selected = {
        'Groups Answered Calls': true,
        'Abandoned By Groups': true,
        'Active Agents': true
      };

      if (this.selectedFilterType.action === 1) {
        (this.options.legend as LegendOption).selected = {
          'Groups Answered Calls': true,
          'Abandoned By Groups': false,
          'Active Agents': false
        };
      } else if (this.selectedFilterType.action === 2) {
        (this.options.legend as LegendOption).selected = {
          'Groups Answered Calls': false,
          'Abandoned By Groups': true,
          'Active Agents': false
        };
      }
    } else if (this.chartType === 'pie') {
      this.options = Object.assign({}, this.optionsPie);

      let seriesName = 'Groups Handled Calls';
      let data = [];

      if (this.selectedFilterType.action === 99) {
        seriesName = 'Groups Handled Calls';
        data = groupedData.map(item => {
          return {
            value: item.totalCalls,
            name: this.reportsService.getExtensionName(item.extension)
          };
        });
      } else if (this.selectedFilterType.action === 1) {
        data = groupedData.map(item => {
          return {
            value: item.answeredByUser,
            name: this.reportsService.getExtensionName(item.extension)
          };
        });
      } else if (this.selectedFilterType.action === 2) {
        data = groupedData.map(item => {
          return {
            value: item.missedCalls,
            name: this.reportsService.getExtensionName(item.extension)
          };
        });
      } else if (this.selectedFilterType.action === 4) {
        data = groupedData.map(item => {
          return {
            value: item.avgTalkDuration,
            name: this.reportsService.getExtensionName(item.extension)
          };
        });
      } else if (this.selectedFilterType.action === 5) {
        data = groupedData.map(item => {
          return {
            value: item.avgWaitDuration,
            name: this.reportsService.getExtensionName(item.extension)
          };
        });
      }

      const totalCalls: SeriesOption = {
        type: 'pie',
        name: seriesName,
        data: data,
      };

      series.push(totalCalls);
    }

    this.options.toolbox[0].feature.myZoom.show = this.showExpand;

    this.updateOptions = {
      series: series,
      toolbox: this.options.toolbox,
    };
  }

  onExpandClick() {
    console.log(this.expandBtn.nativeElement.value);
    if (this.expandBtn.nativeElement?.value === 'bar') {
      this.chartType = 'bar';
      this.updateChart();
    } else if (this.expandBtn.nativeElement?.value === 'pie') {
      this.chartType = 'pie';
      this.updateChart();
    } else {
      this.dialog.open(MatGroupsDashboardZoomDialogComponent, {
        width: '90%',
        height: '90%',
        data: {
          chartData: this.data,
          showActivityPieChart: true,
          filterType: this.selectedFilterType,
          chartType: this.chartType,
        }
      });
    }
  }
}
